import { Filter, FilterType, FilterKey, EApplicantOfferPGKeys } from 'api-paths-cas';
import { orderBy } from 'lodash';
import { IGetFilterGroupsProps } from '..';

const key = FilterKey.COUNTRY_OF_RESIDENCE;
export const getCountryOfResidenceFilter = ({ activeFilters, filterOptions }: IGetFilterGroupsProps): Filter => {
  const filters = activeFilters[key] ?? [];
  let residencyFilterOptions = filterOptions?.[EApplicantOfferPGKeys.RESIDENCE_COUNTRY] || [];
  if (!residencyFilterOptions) {
    console.warn('Residency filter options could not be extracted from filter options.');
    residencyFilterOptions = [];
  }
  const options = residencyFilterOptions.map(country => {
    return {
      label: country.label,
      value: country.value,
      checked: filters.some(filter => filter === country.value),
    };
  });

  const sortedOptions = orderBy(options, [option => option.label.toLowerCase()], ['asc']);

  return {
    name: 'Country of residence',
    key,
    type: FilterType.SELECT_MANY,
    showSearch: true,
    options: {
      SELECT_MANY: sortedOptions,
    },
  };
};
